import { TransactionCashAdditionalData } from "@/model/data/cashFlow/TransactionCashAdditionalData";
import { AxiosResponse } from "axios";
import { PaginatedServiceResponseData } from "../PaginatedServiceResponseData";

export class GetTransactionDetailsCommandResData extends PaginatedServiceResponseData {
    public transactionAdditionalDetails: TransactionCashAdditionalData[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        this.paginatedTotalItems = obj.TotalTransactionsCount;
        if (obj.TransactionAdditionalDetails) {
            this.transactionAdditionalDetails = [];
            obj.TransactionAdditionalDetails.forEach((v) => {
                this.transactionAdditionalDetails.push(TransactionCashAdditionalData.Parse(v));
            });
        }
        console.log("received data: ", obj);
    }
}
